// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__M3m+v","others-header__buttons":"Header_others-header__buttons__Lk2xg"};